// dva 请求全局错误处理
export const dva = {
  config: {
    onError(e) {
      e.preventDefault();
    },
  },
};
